// import html from '../assets/assets/html.svg'

// export const skills = [
//   ["HTML 5", "CSS 3", "Boostrap 5"],
//   ["JavaScript", "React", "Jquery"],
//   ["Babel", "Webpack", "NPM"],
//   ["Tailwind CSS", "Material UI", "JIRA"],
//   ["Postman", "Firebase", "AWS Codepipeline"],
//   ["AWS Amplify", "AWS S3", "Confluence"],
//   ["Trello", "Figma", "Git"],
// ];

import html from "../assets/html.svg";
import css from "../assets/css.svg";
import bootstrap from "../assets/bootstrap.svg";
import javascript from "../assets/javascript.svg";
import React from "../assets/react.svg";
import babel from "../assets/babel.svg";
import webpack from "../assets/webpack.svg";
import npm from "../assets/npm.svg";
import tailwind from "../assets/tailwind.svg";
import materialui from "../assets/material.svg";
import Postman from "../assets/postman.svg";
import firebase from "../assets/firebase.svg";
import AWSCodepipeline from "../assets/codepipeline.svg";
import AWSAmplify from "../assets/amplify.svg";
import AWS from "../assets/se.svg";
import confluence from "../assets/confluence.svg";
import trello from "../assets/trello.svg";
import figma from "../assets/figma.svg";
import git from "../assets/git.svg";
import GitHub from "../assets/github.svg";
import jquery from "../assets/jquery.svg";
import jira from "../assets/jira.svg";
import parcel from "../assets/parcel.svg";
import rollup from "../assets/rollup.svg";
import TicTacToe from "../assets/TicTacToe.svg";
import WebWalk from "../assets/WebWalk.svg";
import TreeVisualizer from "../assets/TreeVisualizer.svg";
import DoodleDesk from "../assets/DoodleDesk.svg";
import CaptureMe from "../assets/CaptureMe.svg";
import client1 from "../assets/img1.jpeg";
import client2 from "../assets/img2.jpeg";
export const skills = [
  [
    {
      name: "HTML",
      img: html,
    },
    {
      name: "CSS",
      img: css,
    },
    {
      name: "Bootstrap",
      img: bootstrap,
    },
  ],
  [
    {
      name: "Javascript",
      img: javascript,
    },
    {
      name: "React",
      img: React,
    },
    {
      name: "Juery",
      img: jquery,
    },
  ],
  [
    {
      name: "Babel",
      img: babel,
    },
    {
      name: "Webpack",
      img: webpack,
    },
    {
      name: "NPM",
      img: npm,
    },
  ],
  [
    {
      name: "Tailwind CSS",
      img: tailwind,
    },
    {
      name: "Material UI",
      img: materialui,
    },
    {
      name: "JIRA",
      img: jira,
    },
  ],
  [
    {
      name: "Postman",
      img: Postman,
    },
    {
      name: "Firebase",
      img: firebase,
    },
    {
      name: "AWS Codepipeline",
      img: AWSCodepipeline,
    },
  ],
  [
    {
      name: "AWS Amplify",
      img: AWSAmplify,
    },
    {
      name: "AWS S3",
      img: AWS,
    },
    {
      name: "Confluence",
      img: confluence,
    },
  ],
  [
    {
      name: "Trello",
      img: trello,
    },
    {
      name: "Figma",
      img: figma,
    },
    {
      name: "Git",
      img: git,
    },
  ],
  [
    {
      name: "Github",
      img: GitHub,
    },
    {
      name: "Rollup",
      img: rollup,
    },
    {
      name: "Parcel",
      img: parcel,
    },
  ],
];

export const coretechdata = [
  {
    name: "HTML",
    img: html,
  },
  {
    name: "CSS",
    img: css,
  },
  {
    name: "Javascript",
    img: javascript,
  },
];

export const frameworkslibraries = [
  {
    name: "React",
    img: React,
  },
  {
    name: "Juery",
    img: jquery,
  },
  {
    name: "Bootstrap",
    img: bootstrap,
  },
  {
    name: "Tailwind CSS",
    img: tailwind,
  },
  {
    name: "Material UI",
    img: materialui,
  },
];

export const builddata = [
  {
    name: "Babel",
    img: babel,
  },
  {
    name: "Webpack",
    img: webpack,
  },
  {
    name: "Rollup",
    img: rollup,
  },
  {
    name: "Parcel",
    img: parcel,
  },
  {
    name: "NPM",
    img: npm,
  },
];

export const apidata = [
  {
    name: "Postman",
    img: Postman,
  },
  {
    name: "Firebase",
    img: firebase,
  },
  {
    name: "AWS Codepipeline",
    img: AWSCodepipeline,
  },
  {
    name: "AWS Amplify",
    img: AWSAmplify,
  },
  {
    name: "AWS S3",
    img: AWS,
  },
];

export const prodata = [
  {
    name: "JIRA",
    img: jira,
  },
  {
    name: "Confluence",
    img: confluence,
  },
  {
    name: "Trello",
    img: trello,
  },
];
export const designdata = [
  {
    name: "Figma",
    img: figma,
  },
];
export const versiondata = [
  {
    name: "Git",
    img: git,
  },
  {
    name: "Github",
    img: GitHub,
  },
  {
    name: "Gitlab",
    img: GitHub,
  },
];

export const projectData = [
  {
    name: "Tic Tac Toe",
    img: TicTacToe,
  },
  {
    name: "Doodle Desk",
    img: DoodleDesk,
  },
  {
    name: "Tree Visualizer",
    img: TreeVisualizer,
  },
  {
    name: "Capture Me",
    img: CaptureMe,
  },
  {
    name: "Web Walk",
    img: WebWalk,
  },
];

export const clientTestimonials = [
  {
    img: client1,
    // title: "Test Title 1",
    content:
      "“I've worked with Namrata on multiple projects; her expertise and precision as a UI developer consistently elevate every design.”",
    name: "Prottay Basu",
    designation: "Asst. Manager at Deloitte UK",
  },
  {
    img: client2,
    // title: "Test Title 2",
    content:
      "“I had the opportunity to work with Namrata Das on the Crazebazar project, where her dedication, UI skills, and collaborative approach made a real difference.”",
    name: "Sourav Seal",
    designation: "Business Analyst at Amazon",
  },
  // {
  //   img: client1,
  //   title: "Test Title 3",
  //   content:
  //     "“Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation .”",
  //   name: "Harry Styles",
  //   designation: "CEO",
  // },
];
